module.exports = {"620623100":"华藏寺镇","620623101":"打柴沟镇","620623102":"安远镇","620623103":"炭山岭镇","620623104":"哈溪镇","620623105":"赛什斯镇","620623106":"石门镇","620623107":"松山镇","620623108":"天堂镇","620623109":"朵什镇","620623201":"东坪乡","620623202":"赛拉隆乡","620623203":"东大滩乡","620623204":"抓喜秀龙乡","620623205":"西大滩乡","620623207":"大红沟乡","620623208":"毛藏乡","620623209":"祁连乡","620623210":"旦马乡","620623401":"天祝建材厂","620623402":"天祝煤电公司"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620623.json
// module id = 2705
// module chunks = 0